import { css } from 'styled-components'
import { colors } from 'utils/colors'
import { FontProps } from 'types/styled'

export type FontFamilyType = 'roboto' | 'roboto-condensed' | 'montserrat'

/* Font Weights */
export const fontWeights = {
  normal: 400,
  light: 300,
  medium: 500,
  bold: 700,
  heavy: 800,
}
export type FontWeightType = keyof typeof fontWeights

/* Font Family */
const fonts = {
  roboto: css`
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
  `,
  'roboto-condensed': css`
    font-family: 'Roboto Condensed', sans-serif;
    -webkit-font-smoothing: antialiased;
  `,
  montserrat: css`
    font-family: 'Montserrat', sans-serif;
    -webkit-font-smoothing: antialiased;
  `,
}

export const fontSizes = [10, 12, 13, 14, 16, 20, 24, 28, 32, 34, 48, 64, 96, 128]

export const font = ({ family, weight, color, size }: FontProps = {}) => css`
  ${family ? fonts[family] : null}
  ${size && `font-size: ${size}px;`}
  ${weight && `font-weight: ${fontWeights[weight]};`}
  ${color && `color: ${colors[color]};`}
`
